function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M232.19,77.7,157.56,34.89a15.22,15.22,0,0,0-15.12,0L67.81,77.7A15.78,15.78,0,0,0,60,91.37V251.44a15.56,15.56,0,0,0,15.4,15.68H224.63A15.56,15.56,0,0,0,240,251.44V91.37A15.78,15.78,0,0,0,232.19,77.7ZM223,250.12H77V92l73-41.89L223,92Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M150,154a31,31,0,1,1,31-31A31,31,0,0,1,150,154Zm0-45a14,14,0,1,0,14,14A14,14,0,0,0,150,109Z"
});

var SvgFreePlan = function SvgFreePlan(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 300 300",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFreePlan, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/free_plan.ba474208.svg";
export { ForwardRef as ReactComponent };